import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, ListItem, Divider, Box, Grid } from "@material-ui/core";
import { CardBase } from "@components/organisms";
import { Image } from "@components/atoms";
import icon_placeholder from "@assets/images/icon_placeholder.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  featureCheck: {
    marginRight: theme.spacing(1),
  },
  logoContainer: {
    width: 40,
    height: 40,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle"
  },
  logoImage: {
    width: "100%",
    height: "100%",
  },
  ctaWrapper: {
    width: "100%",
    flex: 1,
  },
  content: {
    justifyContent: "center",
    alignSelf: "center",
  },
  iconColor: {
    color: theme.palette.primary.main,
  },
}));

/**
 * Component to display the job card
 *
 * @param {Object} props
 */
const CategoryBase = (props) => {
  const {
    title,
    subtitle,
    icon,
    categoryComponent,
    cta,
    className,
    titleProps,
    subtitleProps,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <CardBase className={classes.root} align="left" {...rest}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container alignItems="center">
            <div className={classes.logoContainer}>
              <a href="/">
                {!icon && (
                  <FontAwesomeIcon
                    icon={faFolderOpen}
                    size="2x"
                    className={classes.iconColor}
                  />
                )}
                {icon && (
                  <FontAwesomeIcon
                    icon={icon}
                    size="2x"
                    className={classes.iconColor}
                  />
                )}
              </a>
            </div>

            <Typography
              variant="h6"
              gutterBottom
              className="standard__title"
              {...titleProps}
            >
              <Box fontWeight="fontWeightBold" m={1}>
                {title}
              </Box>
            </Typography>
          </Grid>

          {subtitle && (
            <Typography
              variant="subtitle1"
              color="textSecondary"
              className="standard__subtitle"
              {...subtitleProps}
            >
              {subtitle}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} className="divider-container">
          <Divider className="divider" />
        </Grid>
        <Grid item xs={12} className="content">
          {categoryComponent}
        </Grid>
      </Grid>
      <div className={classes.ctaWrapper}></div>
      {cta && (
        <Grid container>
          <Grid item xs={12} className="divider-container">
            <Divider className="divider" />
          </Grid>
          <Grid item xs={12} className="cta-wrapper" alignItems="flex-end">
            {cta}
          </Grid>
        </Grid>
      )}
    </CardBase>
  );
};

CategoryBase.defaultProps = {
  titleProps: {},
  subtitleProps: {}
};

CategoryBase.propTypes = {
  /**
   *  External classes
   */
  className: PropTypes.string,
  /**
   * Title of the pricing card
   */
  title: PropTypes.string.isRequired,
  /**
   *  Subtitle of the pricing card
   */
  subtitle: PropTypes.string,
  /**
   * The pricing component of the pricing card
   */
  categoryComponent: PropTypes.node,
  /**
   *  CTA button of the pricing card
   */
  cta: PropTypes.node,
  /**
   * Additional props to pass to the title Typography component
   */
  titleProps: PropTypes.object,
  /**
   * Additional props to pass to the subtitle Typography component
   */
  subtitleProps: PropTypes.object,
};

export default CategoryBase;
